(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-discount-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('newsletter-discount-popup')) {
    customElements.define(
      'newsletter-discount-popup',
      class NewsletterDiscountPopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.closeButton = this.querySelector('[data-newsletter-popup-close]');
          this.isSuccess = this.dataset.success === 'true';
          this.storageKey = 'cubis-newsletter-popup';

          if (!this.dialog || !this.closeButton) return;

          this.closeButton.addEventListener('click', () => this.close());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog.addEventListener('close', () => {
            if (!this.isSuccess) this.remember('dismissed');
          });

          if (this.isSuccess) {
            this.remember('subscribed');
            this.open();
            return;
          }

          if (this.dialog.hasAttribute('open')) {
            this.dialog.removeAttribute('open');
            this.open();
            return;
          }

          if (window.Shopify?.designMode || !this.wasSeen()) {
            window.setTimeout(() => this.open(), Number(this.dataset.delay) || 6000);
          }
        }

        open() {
          if (!this.dialog.open) this.dialog.showModal();
        }

        close() {
          if (this.dialog.open) this.dialog.close();
        }

        wasSeen() {
          try {
            const storedValue = window.localStorage.getItem(this.storageKey);
            if (!storedValue) return false;

            const state = JSON.parse(storedValue);
            if (state.value === 'subscribed') return true;
            return state.expires > Date.now();
          } catch (error) {
            return false;
          }
        }

        remember(value) {
          try {
            const expires = value === 'subscribed' ? null : Date.now() + 30 * 24 * 60 * 60 * 1000;
            window.localStorage.setItem(this.storageKey, JSON.stringify({ value, expires }));
          } catch (error) {
            return;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
